import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the Telegram
 * Groups user-picker API.
 *
 * This file drives:
 * - Enhanced API: computed endpoint keys in `enhanceEndpoints`
 * - Hook re-exports: clean name → generated name mapping
 * - MSW mock factories: HTTP method + URL path pattern
 */
export const TELEGRAM_USERS_API_ENDPOINTS = {
  listTelegramUsers: {
    generated: 'usersControllerListTelegramUsersV1',
    method: 'get',
    path: '/api/v1/admin/telegram-users',
  },
} as const satisfies Record<string, EndpointDef>;

export type TelegramUsersEndpointName = keyof typeof TELEGRAM_USERS_API_ENDPOINTS;
